import styled from "styled-components"

export const FounderContainer = styled.section`
height : auto;
margin-bottom: 3rem;
background:  #05386B;
border-radius: 10px;
`

export const FounderWrapper = styled.div`
max-width: 1100px;
margin: 0 auto;
display:flex;
justify-content: center;
align-items: center;

@media screen and (max-width: 768px){
    flex-direction: column;
}
`

export const FounderImage = styled.div`

`

export const Image = styled.img`
width: 80%;
`

export const FounderText = styled.div`
color: #fff;
max-width: 600px;

@media screen and (max-width: 768px){
    max-width: 320px;
    padding-bottom: 20px;
}
`


export const FounderPP = styled.p`
line-height: 2;
text-align: justify;
`

export const FounderP = styled.p`
line-height: 1.5;
text-align: center;
font-size: 1.5rem;
`

export const FounderHead = styled.p`
text-align:center;
color: #fff;
font-style: italic;
padding-bottom: 10px;
`

